import { GENEROS_TREE } from '../constants/musicConstants.js';
import { shippingIndicesFromRow } from './constants/listingShipping.js';

/** Estados en los que el vendedor puede editar el anuncio. */
export const SELLER_EDITABLE_LISTING_STATUSES = ['active', 'reserved', 'paused'];

export function canSellerEditListing(itemOrRow) {
  if (!itemOrRow) return false;
  if (itemOrRow.isAuction || itemOrRow.is_auction) {
    const st = String(itemOrRow.status || '').toLowerCase();
    return st === 'active' || st === 'reserved' || st === 'paused';
  }
  const st = String(itemOrRow.status || '').toLowerCase();
  return SELLER_EDITABLE_LISTING_STATUSES.includes(st);
}

function splitStoredGenre(stored) {
  const s = String(stored ?? '').trim();
  if (!s) return { genero: '', generoSub: '' };
  for (const [key, subs] of Object.entries(GENEROS_TREE)) {
    if (s === key) return { genero: key, generoSub: '' };
    if (Array.isArray(subs) && subs.includes(s)) return { genero: key, generoSub: s };
  }
  return { genero: '', generoSub: s };
}

function photoPreviewsFromRow(row) {
  const cover = row.cover_url ?? row.coverUrl ?? null;
  const photos = Array.isArray(row.photos) ? row.photos.filter(Boolean) : [];
  const p0 = cover || photos[0] || null;
  const p1 = cover && photos[0] === cover ? photos[1] : photos[0] === p0 ? photos[1] : photos[0];
  const p2 = photos.find((u, i) => u && u !== p0 && u !== p1) ?? photos[2] ?? null;
  return [p0, p1 || null, p2 || null].map(u => (u && String(u).trim() ? String(u).trim() : null));
}

/**
 * Rellena el formulario de PagePublicar desde fila `listings` o ítem mapListing.
 * @param {object} row
 * @param {{ pais?: string|null, ciudad?: string|null, localidad?: string|null }} [profileLoc]
 */
export function buildPublicarStateFromListing(row, profileLoc = {}) {
  if (!row) return null;

  const { genero, generoSub } = splitStoredGenre(row.genre);
  const envios = shippingIndicesFromRow(row);
  const previews = photoPreviewsFromRow(row);

  const rowCiudad = String(row.ciudad ?? '').trim();
  const rowLocalidad = String(row.localidad ?? '').trim();
  const profCiudad = String(profileLoc.ciudad ?? '').trim();
  const profLocalidad = String(profileLoc.localidad ?? '').trim();
  const useProfileLoc =
    rowCiudad &&
    rowLocalidad &&
    rowCiudad === profCiudad &&
    rowLocalidad === profLocalidad &&
    String(row.pais ?? '').trim() === String(profileLoc.pais ?? 'España').trim();

  return {
    modo: 'manual',
    done: true,
    esConjunto: !!(row.es_conjunto ?? row.esConjunto),
    artista: row.es_conjunto || row.esConjunto ? '' : String(row.artist ?? ''),
    titulo: row.es_conjunto || row.esConjunto ? '' : String(row.title ?? ''),
    anio: row.year != null ? String(row.year) : '',
    esEdicionEspecial: !!(row.es_edicion_especial ?? row.esEdicionEspecial),
    edicionNombre: row.edicion_nombre ?? row.edicionNombre ?? '',
    edicionCatalogo: row.edicion_catalogo ?? row.edicionCatalogo ?? '',
    edicionContenido: row.edicion_contenido ?? row.edicionContenido ?? '',
    edicionNumerada: !!(row.edicion_numerada ?? row.edicionNumerada),
    edicionNumeroEjemplar: row.edicion_numero_ejemplar ?? row.edicionNumeroEjemplar ?? '',
    conjuntoTitulo: row.conjunto_titulo ?? row.conjuntoTitulo ?? '',
    conjuntoNumDiscos:
      row.conjunto_num_discos != null
        ? Number(row.conjunto_num_discos) || 2
        : row.conjuntoNumDiscos != null
        ? Number(row.conjuntoNumDiscos) || 2
        : 2,
    conjuntoDescripcion: row.conjunto_descripcion ?? row.conjuntoDescripcion ?? '',
    estado: row.condition ?? '',
    sello: row.label ?? '',
    pais: row.country ?? '',
    formato: row.format ?? row.type ?? 'Vinilo 12"',
    genero,
    generoSub,
    precio: row.price != null ? String(row.price) : '',
    obs: row.description ?? '',
    envios,
    locSel: useProfileLoc ? 0 : 1,
    pubProvincia: useProfileLoc ? '' : rowCiudad,
    pubMunicipio: useProfileLoc ? '' : rowLocalidad,
    fotosFiles: [null, null, null],
    fotosPreviews: previews,
    isAuction: !!(row.is_auction ?? row.isAuction),
    listingStatus: String(row.status ?? 'active'),
  };
}
